import { JsonRTEBlockItem } from '@design-system/json-rte';
import React from 'react';

import JsonRTEBlock from '~/components/JsonRTEBlock';

export type FooterLink = {
  title: string;
  url: string;
  ariaLabel?: string;
};

export type FooterColumn = {
  links: FooterLink[];
};

export interface FooterProps {
  logoUrl: string;
  legalInfo?: JsonRTEBlockItem | undefined;
  footerColumns: FooterColumn[];
  secondaryNavigation: FooterLink[];
  copyright: string | undefined;
  description: JsonRTEBlockItem;
}

export const Footer: React.FC<FooterProps> = ({
  logoUrl,
  footerColumns,
  legalInfo,
  secondaryNavigation,
  copyright = '',
  description,
}) => (
  <footer className="footer">
    <div className="footer__wrapper">
      <nav className="footer__columns" aria-label="Footer primary navigation">
        <div className="footer__logo-wrapper">
          <a href="/" className="footer__logo">
            <img src={logoUrl} alt="logo" />
          </a>
          <span className="footer__legal-info">
            {legalInfo && (
              <JsonRTEBlock {...{ rte: legalInfo, pageBlockUI: {} }} />
            )}
          </span>
        </div>
        {footerColumns &&
          footerColumns.map((column) => (
            <ul className="footer__column">
              {column.links.map((link) => (
                <li className="footer__column-item">
                  <a
                    href={link.url}
                    className="footer__link"
                    aria-label={link.ariaLabel || link.title}
                  >
                    {link.title}
                  </a>
                </li>
              ))}
            </ul>
          ))}
      </nav>
      <div className="footer__middle-wrapper">
        <div className="footer__middle">
          <div className="footer__copyright">{copyright}</div>

          <nav
            className="footer__secondary-nav"
            aria-label="Footer secondary navigation"
          >
            <ul className="footer__secondary-list">
              {secondaryNavigation &&
                secondaryNavigation.map((link) => (
                  <li className="footer__secondary-item">
                    <a
                      href={link.url}
                      className="footer__link footer__link--secondary"
                      aria-label={link.ariaLabel || link.title}
                    >
                      {link.title}
                    </a>
                  </li>
                ))}
            </ul>
          </nav>
        </div>
      </div>

      <div className="footer__bottom">
        <JsonRTEBlock {...{ rte: description, pageBlockUI: {} }} />
      </div>
    </div>
  </footer>
);
